<template>
  <v-row no-gutters>
    <v-col>
      <v-card flat>
        <v-card-text class="d-flex flex-wrap px-3 pt-2 pb-1 data-list-header">
          <DataListHeading
            :label="title"
            :disabled="disableAdding"
            :search-label="searchLabel"
            :search-field="searchField"
            :search-value="search"
            :is-header-filter="isHeaderFilter"
            :add-arrow-back="addArrowBack"
            :is-modal="isModal"
            :component-name="componentName"
            data-test="search"
            @add="addNewItem"
            @getSearch="getSearch"
          />
          <slot name="header-filters" />
          <v-badge
            v-if="filledFiltersCount > 0 && $slots.filters"
            bordered
            color="green"
            :content="filledFiltersCount"
            overlap
          >
            <v-btn
              icon
              large
              :color="filtersShow === null ? '' : 'green'"
              @click="showFilters"
            >
              <v-icon>mdi-filter</v-icon>
            </v-btn>
          </v-badge>
          <v-btn
            v-if="filledFiltersCount == 0 && $slots.filters"
            icon
            large
            :color="filtersShow === null ? '' : 'green'"
            @click="showFilters"
          >
            <v-icon>mdi-filter</v-icon>
          </v-btn>

          <slot name="action-buttons" />
          <template v-slot:setting-buttons>
            <v-dialog
              v-if="false"
              v-model="columnsDialog"
              width="500"
            >
              <template v-slot:activator="{ on }">
                <v-btn
                  icon
                  v-on="on"
                >
                  <v-icon>settings</v-icon>
                </v-btn>
              </template>
              <v-card flat>
                <v-card-text>
                  <v-col
                    v-for="(column, index) in columnsSettings"
                    :key="column.name"
                  >
                    <v-row>
                      <v-switch
                        v-model="column.visible"
                        color="primary"
                        class="mt-0"
                        hide-details
                        :label="column.title"
                      />
                      <v-spacer />
                      <v-btn
                        fab
                        text
                        small
                        @click="moveColumnUp(index)"
                      >
                        <v-icon>keyboard_arrow_up</v-icon>
                      </v-btn>
                      <v-btn
                        fab
                        text
                        small
                        @click="moveColumnDown(index)"
                      >
                        <v-icon>keyboard_arrow_down</v-icon>
                      </v-btn>
                    </v-row>
                  </v-col>
                </v-card-text>
                <v-btn
                  color="primary"
                  @click="applyColumnSettings"
                >
                  Застосувати
                </v-btn>
                <v-btn
                  v-if="useSavedColumns"
                  @click="saveColumnSettings"
                >
                  Зберегти
                </v-btn>
                <v-btn @click="columnsDialog = false">
                  Відмінити
                </v-btn>
              </v-card>
            </v-dialog>
          </template>
          <v-col
            v-if="$slots.filters"
            cols="12"
            class="py-1"
          >
            <v-divider
              v-if="filtersShow == 0"
              class="py-1"
            />
            <v-expansion-panels
              v-model="filtersShow"
              flat
            >
              <v-expansion-panel
                hide-actions
              >
                <v-expansion-panel-content>
                  <v-row
                    dense
                    justify="center"
                  >
                    <slot name="filters" />
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>
          <v-col
            v-if="$slots.totals"
            class="px-0 py-0"
          >
            <slot name="totals" />
          </v-col>
        </v-card-text>
        <v-data-table
          :items="items"
          :headers="headers"
          :loading="loading"
          :server-items-length="totalItems"
          :items-per-page="pagination.rowsPerPage"
          hide-default-header
          hide-default-footer
          no-data-text="Даних немає"
          class="elevation-1 mb-1"
          data-test="data-table-list"
        >
          <template v-slot:header>
            <thead class="v-data-table-header">
              <tr>
                <th
                  v-for="header in headers"
                  :key="header.text"
                  :class="[
                    'text-left',
                    header.sortable ? 'sortable' : '',
                    'table-header',
                  ]"
                  :style="`min-width: ${header.minWidth}px; width: ${header.width}px`"
                  @click="applySort(header)"
                >
                  <template v-if="header.tooltip">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <span v-on="header.tooltip ? on : false">
                          {{ header.text }}
                          <v-icon
                            dense
                            small
                          >mdi-help-circle-outline</v-icon>
                        </span>
                      </template>
                      <span>{{ header.tooltip }}</span>
                    </v-tooltip>
                  </template>
                  <template v-else>
                    {{ header.text }}
                  </template>
                  <v-icon
                    v-if="header.sortable"
                    dense
                    small
                    :class="
                      header.isDesc === null ? 'v-data-table-header__icon' : ''
                    "
                  >
                    {{
                      header.isDesc
                        ? "mdi-arrow-up"
                        : "mdi-arrow-up mdi-rotate-180"
                    }}
                  </v-icon>
                </th>
              </tr>
            </thead>
          </template>
          <template v-slot:item="{ item }">
            <tr>
              <td
                v-for="column in visibleColumns"
                :key="column.name"
              >
                <component
                  :is="column.component"
                  v-if="column.component"
                  :value="item[column.name]"
                />
                <span
                  v-else-if="isDate(column.name) && column.type === 'datetime'"
                >{{ item[column.name] != null ? moment(item[column.name]).format("DD.MM.YY HH:mm") : "" }}</span>
                <span
                  v-else-if="isDate(column.name) || column.type === 'date'"
                >{{ item[column.name] != null ? moment(item[column.name]).format("DD.MM.YY") : "" }}</span>
                <span
                  v-else-if="column.name === 'phone'"
                >+{{ item[column.name] }}</span>
                <span v-else-if="column.type === 'decimal'">{{
                  item[column.name] | decimal
                }}</span>
                <a
                  v-else-if="
                    !readonly && (column.isEditLink || column.name === 'id')
                  "
                  :href="`${item.resource}/${item.id}`"
                  @click.prevent="
                    $router.push({
                      path: `${item.resource}/${item.id}`,
                    })
                  "
                >{{ item[column.name] }}</a>
                <span v-else-if="column.type === 'bool'">
                  <v-chip
                    v-if="item[column.name] === true"
                    small
                    label
                    color="red"
                    text-color="white"
                  >
                    {{ item[column.name] ? "Так" : "Ні" }}
                  </v-chip>
                  <v-chip
                    v-else
                    small
                    label
                    color="green"
                    text-color="white"
                  >
                    {{ item[column.name] ? "Так" : "Ні" }}
                  </v-chip>
                </span>
                <span
                  v-else-if="column.cropLimit"
                  class="cellHeightWide"
                >
                  <v-tooltip
                    top
                    min-width="300"
                    max-width="600"
                  >
                    <template v-slot:activator="{ on }">
                      <span v-on="on">{{
                        item[column.name] | cropText(column.cropLimit)
                      }}</span>
                    </template>
                    <span>{{ item[column.name] }}</span>
                  </v-tooltip>
                </span>
                <span
                  v-else-if="column.isColoredChip"
                  style="display: block; text-align: center"
                  class="v-chip__parent"
                >
                  <v-chip
                    :color="chipsColorFn(item, column.name)"
                    outlined
                  >
                    <template v-if="column.type === 'dateHours'">
                      {{ item[column.name] | secondsToHours }}
                    </template>
                    <template v-else>
                      {{ item[column.name] }}
                    </template>
                  </v-chip>
                </span>
                <span
                  v-else-if="column.type === 'circularProgress'"
                  :style="{ display: 'block', textAlign: column.align }"
                >
                  <v-progress-circular
                    :value="item[column.name]"
                    :color="
                      item[column.name] === 0
                        ? 'grey'
                        : item[column.name] > 100
                          ? 'red'
                          : item.color
                    "
                    size="45"
                  >{{ `${item[column.name]}%` }}</v-progress-circular>
                </span>
                <span
                  v-else-if="column.rowType === 'wide'"
                  class="cellHeightWide"
                >{{ item[column.name] }}</span>
                <span v-else-if="column.type === 'dateHours'">
                  {{ item[column.name] | secondsToHours }}
                </span>
                <span v-else-if="column.tooltipData">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <span
                        v-bind="attrs"
                        :class="
                          column.defaultPadding
                            ? 'cellTextHide'
                            : 'cellHeightRegular'
                        "
                        v-on="on"
                      >
                        {{ item[column.name] }}
                      </span>
                    </template>
                    <span>{{ item[column.name] }}</span>
                  </v-tooltip>
                </span>
                <span
                  v-else
                  :class="[column.defaultPadding ? 'cellTextHide' : 'cellHeightRegular', column.cuctomizeClass ? customClassFn(item[column.name]) : '']"
                >
                  {{ item[column.name] }}
                </span>
                <slot
                  v-if="column.type === 'label'"
                  name="label"
                >
                  <span class="cellHeightRegular">
                    <InvoicePaymentsLabel
                      :invoice-amount="item.totalAmount"
                      :payments-amount="item.totalPaymentsAmount"
                    />
                  </span>
                </slot>
              </td>
              <td
                v-if="!readonly"
                class="text-right"
              >
                <v-icon
                  @click="
                    $router.push({
                      path: item.resource + '/' + item.id,
                    })
                  "
                >
                  edit
                </v-icon>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card>
      <div class="text-center">
        <v-pagination
          v-model="pagination.page"
          :disabled="loading"
          :length="pages || 0"
          :total-visible="10"
          color="red lighten-2"
          data-test="pagination"
        />
      </div>
    </v-col>
  </v-row>
</template>

<script>
import Search from "./Search.vue";
import arrayMove from "array-move";
import * as columnSettingsApi from "../backend/columnSettingsApi.js";
import ServiceRecurrenceLabel from "../components/enums/ServiceRecurrenceLabel.vue";
import PaymentTypeLabel from "../components/enums/PaymentTypeLabel.vue";
import UserRolesLabel from "../components/enums/UserRolesLabel.vue";
import { saveDataListState } from "../urlQueryHelper.js";
import InvoicePaymentsLabel from "../views/operations/invoices/InvoicePaymentsLabel";
import DataListHeading from "./DataListHeading.vue";

export default {
  components: {
    ServiceRecurrenceLabel,
    PaymentTypeLabel,
    UserRolesLabel,
    InvoicePaymentsLabel,
    Search,
    DataListHeading,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    resource: {
      type: String,
      required: true,
    },
    columns: {
      type: Array,
      required: true,
    },
    disableAdding: Boolean,
    addRoute: Object,
    useSavedColumns: { type: Boolean, default: false },
    readonly: Boolean,
    filter: [Object, String],
    getItemsFn: Function,
    searchLabel: String,
    searchField: { type: Boolean, default: true },
    isHeaderFilter: { type: Boolean },
    addArrowBack: {
      type: Boolean,
      default: false,
    },
    isModal: {
      type: Boolean,
      default: false,
    },
    componentName: { type: String, default: "" },
    chipsColorFn: {
      type: Function,
      default() {},
      required: false,
    },
    customClassFn: {
      type: Function,
      default() {},
      required: false,
    },
  },
  data: () => ({
    columnsSettings: [],
    columnsDialog: false,
    loading: false,
    items: [],
    totalItems: 0,
    pagination: {},
    search: "",
    waitSearch: false,
    blockHeight: 0,
    filtersShow: null,
    filledFiltersCount: 0,
  }),
  computed: {
    pages() {
      if (this.pagination.rowsPerPage === null || this.totalItems === null) {
        return 0;
      }
      return Math.ceil(this.totalItems / this.pagination.rowsPerPage);
    },
    headers() {
      const headers = this.visibleColumns.map((c) => {
        return {
          name: c.name,
          text: c.title,
          sortable: c.sortable ? c.sortable : false,
          align: c.align ? c.align : "left",
          width: c.width,
          minWidth: c.minWidth,
          isDesc: c.isDesc,
          tooltip: c.tooltip ? c.tooltip : false,
        };
      });
      if (!this.readonly) {
        headers.push({ text: "", sortable: false });
      }
      return headers;
    },
    visibleColumns() {
      const visibleColumns = this.columns.filter(
        (c) => !c.hasOwnProperty("visible") || c.visible
      );

      visibleColumns.sort((a, b) => {
        let aOrder = 0;
        if (a.hasOwnProperty("order")) {
          aOrder = a.order;
        } else {
          aOrder = this.columns.indexOf(a);
        }

        let bOrder = 0;
        if (b.hasOwnProperty("order")) {
          bOrder = b.order;
        } else {
          bOrder = this.columns.indexOf(b);
        }

        if (aOrder < bOrder) {
          return -1;
        }
        if (aOrder > bOrder) {
          return 1;
        }
        return 0;
      });

      return visibleColumns;
    },
    saveDataListState() {
      return saveDataListState;
    },
    sortList() {
      const items = [];
      this.columns.forEach((c) => {
        if (typeof c.isDesc === "boolean") {
          items.push({
            isDesc: c.isDesc,
            name: c.name,
          });
        }
      });

      return items;
    },
    sortParams() {
      const sortParams = {};
      this.sortList.forEach((item, index) => {
        sortParams[`order.${item.name}.isDesc`] = item.isDesc;
        sortParams[`order.${item.name}.order`] = index + 1;
      });
      return sortParams;
    },
  },
  watch: {
    pagination: {
      handler() {
        if (this.columnsSettings && !this.columnSettingsLoading) {
          this.getItems();

          if (
            this.pagination &&
            this.$router.currentRoute.query.page !== this.pagination.page
          ) {
            this.saveDataListState(
              this.pagination.page,
              this.search,
              this.filter,
              this.pagination.rowsPerPage,
              this.sortList
            );
          }
        }
      },
      deep: true,
    },
    search() {
      this.pagination.page = 1;
      if (!this.waitSearch) {
        this.waitSearch = true;
        setTimeout(() => {
          this.saveDataListState(
            this.pagination.page,
            this.search,
            this.filter,
            this.pagination.rowsPerPage,
            this.sortList
          );
          this.getItems().then(() => {
            this.waitSearch = false;
          });
        }, 700);
      }
    },
    columns: {
      handler() {
        this.pagination.page = 1;
        this.updateColumnSettings();
        this.getItems();
      },
      deep: true,
    },
    filter: {
      handler() {
        this.pagination.page = 1;
        this.saveDataListState(
          this.pagination.page,
          this.search,
          this.filter,
          this.pagination.rowsPerPage,
          this.sortList
        );
        this.getItems();
      },
      deep: true,
    },
    sortList: {
      handler() {
        this.pagination.page = 1;
        this.saveDataListState(
          this.pagination.page,
          this.search,
          this.filter,
          this.pagination.rowsPerPage,
          this.sortList
        );
        this.getItems();
      },
      deep: true,
    },
    blockHeight: {
      handler(val) {
        if (val) {
          this.pagination = {
            page: +this.$router.currentRoute.query.page || 1,
            rowsPerPage: Math.round(val / 50),
          };
        }
      },
      immediate: true,
    },
  },
  created() {
    this.pagination = {
      page: +this.$router.currentRoute.query.page || 1,
      rowsPerPage: 0,
    };

    this.search = this.$router.currentRoute.query.searchTerm || "";

    this.columns.forEach((c) => {
      const keys = Object.keys(this.$router.currentRoute.query);
      keys.forEach((k) => {
        if (k.includes(`${c.name}.isDesc`)) {
          this.$set(
            c,
            "isDesc",
            JSON.parse(this.$router.currentRoute.query[k])
          );
        }
      });
    });

    if (this.useSavedColumns) {
      columnSettingsApi.getColumnSettings(this.resource).then((res) => {
        if (res.data) {
          this.applySavedColumnSettings(JSON.parse(res.data.Settings));
        } else {
          this.updateColumnSettings();
        }
      });
    } else {
      this.updateColumnSettings();
    }
  },
  mounted() {
    this.getBlockHeight();
  },
  methods: {
    getItemsFromApi() {
      this.loading = true;
      return new Promise((resolve, reject) => {
        this.getItemsFn(
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.search,
          this.filter,
          this.sortParams
        )
          .then((page) => {
            const items = page.result.map((i) => {
              const item = { id: i.id };
              this.visibleColumns.forEach((c) => {
                if (c.dataPath) {
                  const dataPathSegments = c.dataPath.split(".");
                  let value = i;
                  dataPathSegments.forEach((s) =>
                    value ? (value = value[s]) : ""
                  );
                  item[c.name] = value;
                } else if (c.valueFn) {
                  item[c.name] = c.valueFn(i);
                } else {
                  if (i.hasOwnProperty(c.name)) {
                    item[c.name] = i[c.name];
                  } else if (i.hasOwnProperty(c.name)) {
                    item[c.name] = i[c.name];
                  }
                }
              });
              item.resource = this.resource;
              return item;
            });
            const total = page.totalItems;
            this.loading = false;
            this.$emit("load", page);
            this.filledFilters();
            resolve({ items, total });
          })
          .catch((err) => {
            this.loading = false;
            reject(err);
          });
      });
    },
    getItems() {
      if (!this.pagination.rowsPerPage) return;

      return new Promise((resolve, reject) => {
        this.getItemsFromApi()
          .then((data) => {
            this.items = data.items;
            this.totalItems = data.total;
            resolve();
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    isDate(columnName) {
      var reg = /date+$/i;
      return reg.test(columnName);
    },
    applyColumnSettings() {
      this.columnsSettings.forEach((cs, index) => {
        const column = this.columns.find((c) => c.name === cs.name);
        if (column) {
          this.$set(column, "visible", cs.visible);
          this.$set(column, "order", index);
        }
      });
      this.columnsDialog = false;
    },
    moveColumnUp(index) {
      this.columnsSettings = arrayMove(
        this.columnsSettings,
        index,
        index - 1 > -1 ? index - 1 : 0
      );
    },
    moveColumnDown(index) {
      this.columnsSettings = arrayMove(this.columnsSettings, index, index + 1);
    },
    applySavedColumnSettings(settings) {
      if (!settings) {
        return;
      }
      settings.forEach((s) => {
        const column = this.columns.find((c) => c.name === s.name);
        if (column) {
          this.$set(column, "visible", s.visible);
          this.$set(column, "order", s.order);
        }
      });
    },
    updateColumnSettings() {
      this.columnsSettings = this.columns.map((c) => {
        return {
          title: c.title,
          name: c.name,
          visible: c.hasOwnProperty("visible") ? c.visible : true,
          order: c.hasOwnProperty("order") ? c.order : 0,
        };
      });

      this.columnsSettings.sort((a, b) => {
        return a.order - b.order;
      });
    },
    saveColumnSettings() {
      this.applyColumnSettings();
      columnSettingsApi
        .saveColumnSettings(this.resource, this.columns)
        .then(() => {});
    },
    addNewItem() {
      this.$router.push(
        this.addRoute ? this.addRoute : { path: this.resource + "/0" }
      );
    },
    getSearch(search) {
      this.search = search;
    },
    applySort(column) {
      if (!column.sortable) return;

      let isDesc = null;
      switch (column.isDesc) {
        case null:
          isDesc = false;
          break;
        case false:
          isDesc = true;
          break;
        case true:
          isDesc = null;
          break;
        default:
          break;
      }
      this.columns.forEach((c) => {
        if (c.name === column.name) {
          this.$set(c, "isDesc", isDesc);
        }
      });
    },
    getBlockHeight() {
      const elHeader = document.getElementsByClassName("data-list-header");
      const elTableHeader = document.getElementsByClassName("table-header");
      const heightHeader = elHeader.length ? elHeader[0].offsetHeight : 0;
      const heightTableHeader = elTableHeader.length
        ? elTableHeader[0].offsetHeight
        : 0;
      const headerEl = document.getElementsByTagName("header");
      const heightHeaderEl = headerEl[0].offsetHeight;
      const pageEl = document.getElementsByClassName("v-pagination");
      const heightPageEl = pageEl[0].offsetHeight;
      this.blockHeight =
        window.innerHeight -
        heightHeader -
        heightTableHeader -
        heightHeaderEl -
        heightPageEl -
        55;
    },
    showFilters() {
      const value = this.filtersShow != null ? null : 0;
      this.filtersShow = value;
    },
    filledFilters(index, recursion = false){
      this.filledFiltersCount = recursion ? this.filledFiltersCount : 0;

      const filterObj = recursion ? this.filter[index] : this.filter;
      if (filterObj){
        var keys = Object.keys(filterObj);
        keys.forEach(i => {
          if (typeof filterObj[i] === "object"){
            this.filledFilters(i, true);
          } else {
            if (filterObj[i] != ""){
              if (i === "id" && recursion){
                this.filledFiltersCount ++;
              }
              else if (!recursion) {
                this.filledFiltersCount ++;
              }
            }
          }
        });
      }
    },
  },
};
</script>
<style scoped>
.cellHeightRegular {
  display: inline-block;
  min-height: 43px;
  overflow: hidden;
  padding: 13px 0;
}

.cellHeightWide {
  display: inline-block;
  min-height: 43px;
  overflow: hidden;
  padding: 4px 0;
}

.v-chip__parent span {
  display: block;
  text-align: center;
}

.cellTextHide {
  display: -webkit-inline-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 5px 0 0;
}
</style>
